export default "* Bål\n* Løvtræ\n* Tegnekul";